import {Center, Alert} from '@mantine/core'
import {ReactNode} from 'react'
import {ErrorBoundary} from 'react-error-boundary'
import {HiExclamationCircle} from 'react-icons/hi2'

export const SErrorBoundary = ({children}: {children: ReactNode}) => (
  <ErrorBoundary
    fallbackRender={({error}) => (
      <Center className=''>
        <Alert icon={<HiExclamationCircle size={16} />} title={error.name} color={'red'}>
          Something went wrong and it is probably a bug:
          <div>
            <code className='mt-5'>{error.message}</code>
          </div>
        </Alert>
      </Center>
    )}>
    {children}
  </ErrorBoundary>
)
